var _path, _rect, _rect2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveCampaignIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2L12.002 7.16756C12.0027 8.94863 14.1558 9.84047 15.4157 8.58155L19.0711 4.92893L15.4185 8.58435C14.1595 9.84424 15.0514 11.9973 16.8324 11.998L22 12L16.8324 12.002C15.0514 12.0027 14.1595 14.1558 15.4185 15.4157L19.0711 19.0711L15.4157 15.4185C14.1558 14.1595 12.0027 15.0514 12.002 16.8324L12 22L11.998 16.8324C11.9973 15.0514 9.84424 14.1595 8.58435 15.4185L4.92893 19.0711L8.58155 15.4157C9.84047 14.1558 8.94863 12.0027 7.16756 12.002L2 12L7.16756 11.998C8.94863 11.9973 9.84047 9.84424 8.58155 8.58435L4.92893 4.92893L8.58435 8.58155C9.84424 9.84047 11.9973 8.94863 11.998 7.16756L12 2Z",
    fill: "#FFE4DB",
    stroke: "#FE5D26",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 9.5,
    width: 0.01,
    height: 0.01,
    stroke: "#FE5D26",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 14.5,
    width: 0.01,
    height: 0.01,
    stroke: "#FE5D26",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9L9 15",
    stroke: "#FE5D26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveCampaignIcon);
export default __webpack_public_path__ + "static/media/liveCampaignIcon.2ccf7642bfd630cbce4c06d122ab7d10.svg";
export { ForwardRef as ReactComponent };